import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Button } from 'antd';
import logo from '../../../images/logo.png';
import { fromValidate } from '../../../helpers';
import { history } from '../../../helpers';

class ResetPassword extends Component {

	constructor(props) {
		super(props);
		this.state = {
			formError: {},
			formSubmit: false,
			user: {},
			userNumber: '****7890',
			isSuccess: true,
		}
	}

	handleChange = (e) => {
		const user = Object.assign({}, this.state.user)
		const name = e.target.name;
		const value = e.target.value;
		user[name] = value;
		this.setState({ user });

		if (this.state.formSubmit) {
			this.setState({ formError: {} })
			const formValidation = fromValidate(this.fromNode);
			if (!formValidation.valid) {
				this.setState({ formError: formValidation.invalidationEle })
			}
		}
	}

	goToLogin = () => {
		history.push('/login')
	}

	render() {
		const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
		return (
			<div className='reset-container'>
				<div className='login-box'>
					<div className='upload-heading-txt'>RESET PASSWORD</div>
					<form ref={node => this.fromNode = node} noValidate autoComplete="off" onSubmit={(e) => { this.handleSubmit(e) }}>
						<div>
							<div>
								<input
									required
									id="currentPassword"
									label="Current Password"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Current Password"
									value={user.currentPassword}
									name="currentPassword"
									error={formSubmit && formError['currentPassword'] && (!formError['currentPassword'].valid)}
									onChange={(e) => { this.handleChange(e) }}
								/>
								<input
									required
									id="newPassword"
									label="New Password"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="New Password"
									value={user.newPassword}
									name="newPassword"
									error={formSubmit && formError['newPassword'] && (!formError['newPassword'].valid)}
									onChange={(e) => { this.handleChange(e) }}
								/>
								<input
									required
									id="confirmNewPassword"
									label="Confirm New Password"
									type="password"
									className='form-textfield-containt'
									variant="outlined"
									placeholder="Confirm New Password"
									value={user.confirmNewPassword}
									name="confirmNewPassword"
									error={formSubmit && formError['confirmNewPassword'] && (!formError['confirmNewPassword'].valid)}
									onChange={(e) => { this.handleChange(e) }}
								/>
							</div>
							<div className="reset-footer-buttons">
								<Button className='btn-login mg-top' onClick={this.goToLogin}>RESET PASSWORD</Button>
							</div>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(ResetPassword);